import { render, staticRenderFns } from "./OriginatorsFilter.vue?vue&type=template&id=688dc953&"
import script from "./OriginatorsFilter.vue?vue&type=script&lang=ts&"
export * from "./OriginatorsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports